import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faInstagram, faTiktok, faYoutube } from "@fortawesome/free-brands-svg-icons";

function Topbar({ text }) {
  if (!text) return null;

  return (
    <div className="w-full bg-black text-white text-xs flex justify-between items-center px-4 py-1">
      <div className="flex space-x-4">
        <a href="#contact" className="hover:text-primary transition-colors">Contact</a>
      </div>
      <div className="text-center text-xs font-light">{text}</div>
      <div className="flex space-x-3 text-sm">
        <a href="https://www.facebook.com/61557530745252/" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="hover:text-blue-400 transition-colors">
          <FontAwesomeIcon icon={faFacebookF} />
        </a>
        <a href="https://www.instagram.com/pisu.tn/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="hover:text-pink-400 transition-colors">
          <FontAwesomeIcon icon={faInstagram} />
        </a>
        <a href="https://www.tiktok.com/@pisu.tn" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="hover:text-white transition-colors">
          <FontAwesomeIcon icon={faTiktok} />
        </a>
        <a href="https://www.youtube.com/@Pisu-tn" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="hover:text-red-400 transition-colors">
          <FontAwesomeIcon icon={faYoutube} />
        </a>
      </div>
    </div>
  );
}

export default Topbar;
